// A "view in browser" PDF opens its tab on the click (a later window.open is
// popup-blocked), but the request may come back queued. The tab is parked here so
// the export-progress write path can hand it the finished file instead of closing it.
const pendingTabs = new Map();

// A job that never reports terminal (dead worker, dropped socket) would otherwise pin a
// window reference for the life of the session.
const TAB_TTL_MS = 30 * 60 * 1000;

const sweepExpiredTabs = () => {
  const now = Date.now();

  pendingTabs.forEach(({ tab, registeredAt }, jobId) => {
    if (tab.closed || now - registeredAt > TAB_TTL_MS) pendingTabs.delete(jobId);
  });
};

export const registerPendingExportTab = (exportJobId, tab) => {
  sweepExpiredTabs();

  if (!exportJobId || !tab || tab.closed) return false;

  pendingTabs.set(exportJobId, { tab, registeredAt: Date.now() });
  return true;
};

export const releasePendingExportTab = (exportJobId) => pendingTabs.delete(exportJobId);

export const resolvePendingExportTab = ({ exportJobId, status, downloadUrl }) => {
  const { tab } = pendingTabs.get(exportJobId) || {};
  if (!tab) return false;

  if (tab.closed) {
    pendingTabs.delete(exportJobId);
    return false;
  }

  if (status === 'completed' && downloadUrl) {
    tab.location.replace(downloadUrl);
    pendingTabs.delete(exportJobId);
    return true;
  }

  if (status === 'failed') {
    tab.close();
    pendingTabs.delete(exportJobId);
    return false;
  }

  return false;
};
